"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentContent = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
const pins_shared_1 = require("@lessonup/pins-shared");
const AssignmentPin_1 = require("./AssignmentPin");
const AssignmentUtils_1 = require("./AssignmentUtils");
var AssignmentContent;
(function (AssignmentContent) {
    // export type UpdateData = Omit<AssignmentContent, '_id' | 'creationDate'>;
    AssignmentContent.excludedComparisonPaths = ['createdAt', 'migratedAt', 'modifiedAt'];
})(AssignmentContent || (exports.AssignmentContent = AssignmentContent = {}));
(function (AssignmentContent) {
    function updateFields(data) {
        const updateFields = {};
        if (!(0, lodash_1.isNil)(data.testPoints))
            updateFields['testPoints'] = data.testPoints;
        if (!(0, lodash_1.isNil)(data.ownerId))
            updateFields['ownerId'] = data.ownerId;
        (0, lodash_1.forEach)(data.pins, (pin) => {
            const pinId = pin.pinId;
            //pin
            if (!(0, lodash_1.isUndefined)(pin.order))
                updateFields[`pins.${pinId}.order`] = pin.order;
            if (!(0, lodash_1.isUndefined)(pin.testPoints))
                updateFields[`pins.${pinId}.item.testPoints`] = pin.testPoints;
        });
        const cleaned = (0, utils_1.omitDeepUndefined)(updateFields);
        if (!(0, lodash_1.isEmpty)(cleaned)) {
            cleaned['modifiedAt'] = Date.now();
        }
        return cleaned;
    }
    AssignmentContent.updateFields = updateFields;
    function createFromLesson(assignmentId, ownerId, type, lessonData, createdAt, options) {
        const isTest = type === 'test';
        // TODO @DAVEY: should do something with isTest
        // const assignmentPins = lessonData.pins.map((pin) => AssignmentPin.assignmentPinFromLessonPin(pin, isTest));
        const assignmentPins = lessonData.pins.map((pin) => AssignmentPin_1.AssignmentPin.assignmentPinFromTeacherPin(pin));
        const pins = isTest ? AssignmentUtils_1.AssignmentUtils.pinsExcluding(assignmentPins, 'homework') : assignmentPins;
        const pinDict = (0, lodash_1.keyBy)(pins, (p) => p._id);
        const { name, differentation, country, durationInMin, schoolType, levels, years, themes, channel } = lessonData.lesson;
        const content = {
            _id: assignmentId,
            type,
            name: name || '',
            createdAt,
            modifiedAt: createdAt,
            ownerId,
            diff: differentation || undefined,
            pins: pinDict,
            subject: options.subject || (0, lodash_1.first)(lessonData.lesson.subjects),
            groupId: options.groupId,
            module: options.module,
            message: options.message,
            language: options.language,
            origin: options.origin,
            showPhases: lessonData.lesson.showPhases === true,
            phases: (0, lodash_1.map)(lessonData.lesson.phases, (phase) => ({
                label: phase.label || '',
                subtitle: !phase.subtitle ? undefined : phase.subtitle,
            })),
            products: !(0, lodash_1.isEmpty)(lessonData.lesson.products) ? lessonData.lesson.products : undefined,
            country,
            durationInMin: durationInMin || undefined,
            schoolType: schoolType || undefined,
            levels: levels || undefined,
            years: years || undefined,
            themes,
            channel: channel || undefined,
            // TODO: Something with tests
            // testPoints: type === 'test' ? sumBy(pins, (pin) => pin.settings.testPoints || 0) : undefined,
            testPoints: undefined,
            // NOTE: This should always be "v2" after the revamp of the homework with the new lesson data model.
            version: lessonData.lesson.version, // undefined for classic lessons and "v2" for V2 lessons.
        };
        return content;
    }
    AssignmentContent.createFromLesson = createFromLesson;
    function updateFromLesson(old, lessonData, options) {
        const updated = createFromLesson(old._id, old.ownerId, old.type, lessonData, old.createdAt, options);
        return {
            ...updated,
            // we don't want to update these properties
            migratedAt: old.migratedAt,
        };
    }
    AssignmentContent.updateFromLesson = updateFromLesson;
    function optionsFromContent(data) {
        const { content, meta } = data;
        return {
            groupId: content.groupId,
            order: meta.order,
            module: content.module,
            subject: content.subject,
            message: content.message,
            label: meta.label,
            language: content.language,
            origin: content.origin,
        };
    }
    AssignmentContent.optionsFromContent = optionsFromContent;
    function isRealtime(assignment) {
        return assignment.type == 'realtime';
    }
    AssignmentContent.isRealtime = isRealtime;
    function isHomework(assignment) {
        return assignment.type == 'homework';
    }
    AssignmentContent.isHomework = isHomework;
    function isTest(assignment) {
        return assignment.type == 'test';
    }
    AssignmentContent.isTest = isTest;
    function isLinkAssignment(assignment) {
        if (!isHomework(assignment))
            return false;
        return assignment.origin === 'link';
    }
    AssignmentContent.isLinkAssignment = isLinkAssignment;
    function pinsInPhases(phases, pins) {
        const phaseNameMap = phases.map((phase) => phase.label);
        const phaseNames = phaseNameMap.reduce((acc, label) => {
            acc[label] = [];
            return acc;
        }, {});
        return pins.reduce((acc, pin) => {
            const order = pin.order || pins_shared_1.defaultGroupOrder;
            if (order.startsWith(pins_shared_1.defaultGroup)) {
                acc[phaseNameMap[0]].push(pin);
            }
            else {
                const orderIndex = (0, pins_shared_1.getGroupNumberFromOrder)(order) - 1;
                acc[phaseNameMap[orderIndex]].push(pin);
            }
            return acc;
        }, phaseNames);
    }
    AssignmentContent.pinsInPhases = pinsInPhases;
    function firstPhaseWithPins(phasePins) {
        const arrayEntry = Object.entries(phasePins).find(([, value]) => value.length > 0);
        if (!arrayEntry)
            return;
        return arrayEntry[0];
    }
    AssignmentContent.firstPhaseWithPins = firstPhaseWithPins;
})(AssignmentContent || (exports.AssignmentContent = AssignmentContent = {}));
//# sourceMappingURL=AssignmentContent.js.map